import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";


// 👇 Combine the interfaces to represent a full video Topic item
export type IVideoTopic = any;

export const EditDiscussionVideoLessonsSlice = createSlice({
  name: "EditDiscussionVideoLessonsSlice",
  initialState: {} as IReduxState<IVideoTopic>,
  reducers: {
    EditDiscussionVideoLessons: (state, action) => {
      state.isLoading = true;
    },

    successEditDiscussionVideoLessons: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureEditDiscussionVideoLessons: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  EditDiscussionVideoLessons,
  successEditDiscussionVideoLessons,
  failureEditDiscussionVideoLessons,
} = EditDiscussionVideoLessonsSlice.actions;

export default EditDiscussionVideoLessonsSlice.reducer;
